import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { Container } from './Container'
import style from './MessagePage.module.sass'

export type MessagePageProps = {
	title?: string
	returnLinkText?: string
}

export const MessagePage: FunctionComponent<MessagePageProps> = ({ title, returnLinkText }) => {
	return (
		<Container>
			<div className={style.wrapper}>
				<h1 className={style.title}>{title}</h1>
				<Link href="/" className={style.returnLink}>
					{returnLinkText}
				</Link>
			</div>
		</Container>
	)
}
